import React from 'react';
import styled from 'styled-components';
import DavieLogoWhite from '../Assets/davieai-logo-white.png';
import ExitToAppSharpIcon from '@material-ui/icons/ExitToAppSharp';
import SettingsIcon from '@material-ui/icons/Settings';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import NotificationsIcon from '@material-ui/icons/Notifications';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import Tooltip from '@mui/material/Tooltip';
import { useAuth } from '../Contexts/AuthContext';
import { useHistory, useLocation } from 'react-router-dom';
import LifewiseBrandLogo from '../Assets/a-lifewise-brand-logo.png';
const FooterContainer = styled.div`
    margin-top: 50px;
    height: 228px;
    display: flex;
    flex-direction: column;
`;

const FooterBlueBar = styled.div`
    background-color: #2e69fe;
    height: 68px;
    display: flex;
    justify-content: center;
    padding-left: 12px;
    padding-right: 12px;
`;

const BlueBarContent = styled.div`
    display: flex;
    width: 100%;
    max-width: 1500px;
    height: 100%;
    align-items: center;
`;

const DavieLogo = styled.img`
    margin-left: auto;
    width: 130px;
    object-fit: contain;
`;

const LWBrandLogo = styled.img`
    /* margin-bottom: 20px; */
    margin-left: auto;
    width: 200px;
    object-fit: contain;
`;
const RightsReserved = styled.div`
    margin-top: 20px;
`;

const Icon = styled.div`
    display: flex;
    justify-content: space-evenly;
    width: 200px;
    margin-right: auto;
    color: white;

    .clickable {
        cursor: pointer;
    }
`;

const FooterGraySection = styled.div`
    background-color: #e6e9f1;
    height: 160px;
    display: flex;
    justify-content: center;
    padding-left: 12px;
    padding-right: 12px;
`;

const FooterGrayContent = styled.div`
    display: flex;
    width: 100%;
    max-width: 1500px;
    height: 100%;
    align-items: center;
`;

const LifewiseBrandContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: auto;
`;

const GrayLinksContainer = styled.div`
    display: flex;
    margin-right: auto;

    @media only screen and (max-width: 620px) {
        flex-direction: column;
    }
`;

const Links = styled.div`
    cursor: pointer;
    :hover {
        color: #2e69fe;
    }
`;

const Line = styled.div`
    border-right: 2px solid black;
    margin-left: 20px;
    margin-right: 20px;
`;

const Footer = () => {
    const history = useHistory();

    const { logout } = useAuth();

    const handleLogout = async () => {
        await logout();
    };

    const handleSettingsRoute = () => {
        history.push('/portal/settings');
    };

    const handleHelpWikiRoute = () => {
        window.open('https://wiki.davie.ai/');
    };

    const handleDavieExpertsLink = () => {
        window.open('https://davieexperts.com');
    };

    const handleAccountLink = () => {
        history.push('/portal/settings/accountInformation');
    };
    return (
        <FooterContainer>
            <FooterBlueBar>
                <BlueBarContent>
                    <Icon>
                        <Tooltip title="Davie Experts">
                            <AccessibilityNewIcon
                                className="clickable"
                                onClick={() => handleDavieExpertsLink()}
                            />
                        </Tooltip>
                        {/* <Tooltip title="Wiki">
                            <HelpCenterIcon
                                className="clickable"
                                onClick={() => handleHelpWikiRoute()}
                            />
                        </Tooltip> */}

                        <Tooltip title="Settings">
                            <SettingsIcon
                                className="clickable"
                                onClick={() => handleSettingsRoute()}
                            />
                        </Tooltip>

                        <Tooltip title="Logout">
                            <ExitToAppSharpIcon
                                className="clickable"
                                onClick={() => handleLogout()}
                            />
                        </Tooltip>
                    </Icon>
                    <DavieLogo src={DavieLogoWhite} />
                </BlueBarContent>
            </FooterBlueBar>
            <FooterGraySection>
                <FooterGrayContent>
                    <GrayLinksContainer>
                        <Links onClick={() => handleAccountLink()}>Account</Links>
                        <Line />
                        <Links onClick={() => handleLogout()}>Sign Out</Links>
                    </GrayLinksContainer>
                    <LifewiseBrandContainer>
                        <LWBrandLogo src={LifewiseBrandLogo} />
                        <RightsReserved>
                            © 2023 LifeWise Digital Inc., All Rights Reserved
                        </RightsReserved>
                    </LifewiseBrandContainer>
                </FooterGrayContent>
            </FooterGraySection>
        </FooterContainer>
    );
};

export default Footer;
